module.exports = __webpack_public_path__ + "static/media/physical_mental_rotate.536284b6.jpg";